import React from "react";
import { fetch } from "Shared/config";
import { AppleLogo, FacebookLogo, GoogleLogo } from "Shared/icons";

export const SnAuth = () => {
	function snAuth(type) {
		window.open(`${fetch.base}api/auth/${type}-web`, "_self").focus();
	}
	return (
		<>
			<AppleLogo onClick={() => snAuth("apple")} className={"mr-30"} />
			<GoogleLogo onClick={() => snAuth("google")} className={"mr-30"} />
			<FacebookLogo onClick={() => snAuth("facebook")} />
		</>
	);
};
